import React from 'react';
import ChannelLabel from '@/pages/opinion/components/ChannelLabel';
import BubbleCommon, {
  shortGoogleText,
} from '@/pages/opinion/components/BubbleCommon';
import '@/pages/opinion/components/UserScoreBox/index.scss';
import ScoreTrendCharts from '../../components/ScoreTrendCharts';
import {
  formatter,
  listTimeTitleFunc,
} from '@/pages/opinion/components/ChartCommon/formatter';
import { reviewsFormat, scoreFormat } from '@/pages/opinion/utils/value';
import { getPercentageInfo } from '@/pages/opinion/utils';
import { useHistory, useIntl } from 'umi';
import moment from 'moment';
import { goStatsDetailAction } from '../../../stats/Detail';

export default function ScoreTrendBox({
  gameInfo,
  scoreApiErr,
  filterParams,
  platformData,
  platform,
}: any) {
  const { formatMessage } = useIntl();
  const history = useHistory();
  return (
    <div className="dbo-scorebox">
      <div className="dbo-scorebox-hd">
        <BubbleCommon
          style={{ display: 'flex' }}
          placement="top"
          showIcon={platform === 'google play'}
          tipsMap={platform === 'google play' ? shortGoogleText : undefined}
        >
          <div className="dbo-scorebox-hd-text">
            <ChannelLabel
              textClassName="dbo-scorebox-hd-tit"
              channel_name={platform}
            ></ChannelLabel>
          </div>
        </BubbleCommon>
      </div>
      {/* 没有数据情况需传入nodata=true */}
      <div className="dbo-scorebox-bd">
        <div className="echart-data">
          <ScoreTrendCharts
            tooltipFormatter={(params: any) => {
              const newParams = params.filter(
                (v: any) =>
                  v.seriesType === 'bar' && v.seriesName !== 'total总数',
              ); // 过滤掉'total总数'的柱子
              const lineParams = params.filter(
                (v: any) => v.seriesType === 'line',
              );
              // 时间
              let dataTime = listTimeTitleFunc(
                newParams[0]?.axisValue,
                filterParams?.date_type,
              );

              // 计算总人数
              let totalReviews = 0;
              for (let i = 0; i < newParams.length; i++) {
                if (
                  newParams[i].seriesName != '' &&
                  newParams[i].value !== undefined &&
                  newParams[i].value !== 0
                ) {
                  totalReviews += newParams[i].value;
                }
              }

              const lineRecords: any[] = [];
              const barRecords: any[] = [];

              for (let i = 0; i < lineParams.length; i++) {
                const { marker, seriesName } = lineParams[i];
                lineRecords.push({
                  type: `<span class="chart-common-formatter-marker">${marker}</span>&nbsp;${formatMessage(
                    { id: seriesName },
                  )}`,
                  score: scoreFormat(lineParams[i]?.value),
                });
              }

              barRecords.push({
                type: formatMessage({ id: 'Sum of Reviews' }),
                score: reviewsFormat(totalReviews),
                percentage: '100%',
              });

              for (let i = 0; i < newParams.length; i++) {
                if (
                  newParams[i].seriesName != '' &&
                  newParams[i].value !== undefined &&
                  newParams[i].value !== 0
                ) {
                  const { marker } = newParams[i];

                  barRecords.push({
                    type: `<span class="chart-common-formatter-marker">${marker}</span>&nbsp;<span class="tooltip-star tooltip-star-${newParams[i].seriesName[0]}"></span>`,
                    score: reviewsFormat(newParams[i].value),
                    percentage: getPercentageInfo(
                      newParams[i].value,
                      totalReviews,
                      2,
                    ),
                  });
                }
              }

              return formatter({
                title: dataTime,
                tables: [
                  {
                    showHeader: false,
                    records: lineRecords,
                    columns: [
                      {
                        key: 'type',
                      },
                      {
                        weight: 'bold',
                        align: 'right',
                        key: 'score',
                      },
                    ],
                  },
                  {
                    records: barRecords,
                    columns: [
                      {
                        key: 'type',
                        header: formatMessage({ id: 'Rating' }),
                      },
                      {
                        weight: 'bold',
                        align: 'right',
                        key: 'score',
                        header: formatMessage({ id: 'Reviews' }),
                      },
                      {
                        weight: 'bold',
                        align: 'right',
                        key: 'percentage',
                        header: formatMessage({ id: 'Share-1' }),
                      },
                    ],
                  },
                ],
              });
            }}
            filterParams={filterParams}
            platformData={platformData}
            onClick={(params: any) => {
              let start_time = moment(params.name).format('YYYY-MM-DD');
              let end_time = moment(params.name).format('YYYY-MM-DD');

              if (filterParams.date_type === 'weekly') {
                end_time = moment(start_time)
                  .add(6, 'days')
                  .format('YYYY-MM-DD');
              } else if (filterParams.date_type === 'hourly') {
                start_time = moment(params.name).format('YYYY-MM-DD HH:mm:ss');
                end_time = moment(params.name)
                  .endOf('h')
                  .format('YYYY-MM-DD HH:mm:ss');
              }

              let {
                channel_comments,
                channel_social,
                channel_securitys,
                channel_news,
                channel: channelInfo,
                channel_type,
                ...otherFilter
              } = filterParams;
              console.log(platform);
              goStatsDetailAction({
                path: `/opinion/Feeds/Feeds?tab=gameStore`,
                params: {
                  statsDetailType: 'feeds-gameStoreLine',
                  ...otherFilter,
                  start_time,
                  end_time,
                  channel: [platform],
                  channel_type: 'comments',
                },
                history,
              });
            }}
          ></ScoreTrendCharts>
        </div>
      </div>
    </div>
  );
}
